import React, { useState, useEffect } from 'react'
import PrimaryButton from '../Buttons/PrimaryButton'
import { connect } from 'react-redux'
import ProgressBar from '../ProgressBar/index'
import importer from '@takedapdt/biolife-core/src/importer'
import { formatPoints } from '../../Helpers/Utils'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
const { gameStepStatus } = importer('Constant/Utils', null)
const LoaderSpinner = importer('Components/Loaders/LoaderSpinner')
const loyaltyActions = importer('Stores/Loyalty/Actions')
import { ReactComponent as CompletedMedalIcon } from '../../../assets/media/icons/ndq-mission-completed-medal.svg'
import './styles.scss'
import { useScreenSize } from '../../Contexts/ResponsiveContextProvider'

const GameStepComplete = ({ donor, getLoyaltyGameData, loyaltyGameDataSuccess, getLoyaltyGameDataLoading, onClose, points }) => {
  const [progressData, setProgressData] = useState(0)
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation('LoyaltyGame')
  const { isMobileWidth } = useScreenSize()

  useEffect(() => {
    donor && getLoyaltyGameData(donor?.sfid)
  }, [donor])

  useEffect(() => {
    // To calculate the progress bar value
    if (loyaltyGameDataSuccess?.stepsData?.length) {
      // Multiplying it by 20 to get the percentage value for progressing
      let progressValue = loyaltyGameDataSuccess?.stepsData?.filter((step) => step?.completed)?.length * 20
      if (progressData != progressValue) setProgressData(progressValue)
    }
  }, [loyaltyGameDataSuccess])

  const onContinueClick = () => {
    if (location?.pathname != '/dashboard/donor-dashboard') {
      navigate('/dashboard/donor-dashboard')
    } else {
      onClose()
    }
  }

  return (
    <div className='step-main-container'>
      {getLoyaltyGameDataLoading ? (
        <LoaderSpinner />
      ) : loyaltyGameDataSuccess ? (
        <div className='step-container'>
          <div className='step-content-container'>
            <CompletedMedalIcon width='80' height='85' />
            <div className='step-mission-complete'>{t('missionComplete')}</div>

            <ProgressBar
              value={progressData}
              totalPoints={formatPoints(loyaltyGameDataSuccess?.totalGamePoints)}
              totalSteps={loyaltyGameDataSuccess?.stepsData}
              showPoints={true}
              pointsToBeShown={points}
            />
          </div>
          <PrimaryButton
            variant={'outline_blue'}
            text={t('backToQuest')}
            style={{ margin: '0 auto', width: '100%', maxWidth: isMobileWidth ? '342px' : '358px' }}
            onClick={() => onContinueClick()}
          />
        </div>
      ) : null}
    </div>
  )
}

const mapStateToProps = (state) => ({
  donor: state.donors.donors?.data,
  loyaltyGameDataSuccess: state.loyalty?.getLoyaltyGameDataSuccess,
  getLoyaltyGameDataLoading: state.loyalty?.getLoyaltyGameDataLoading
})

const mapDispatchToProps = (dispatch) => ({
  getLoyaltyGameData: (donorSfid) => dispatch(loyaltyActions.getLoyaltyGameData(donorSfid))
})

export default connect(mapStateToProps, mapDispatchToProps)(GameStepComplete)
